import type { UUID } from '@/utils/uuid';

export const roleQueryKeys = {
  list: (tenantId?: UUID, limit?: number, filter?: string) =>
    ['roles', tenantId, limit ?? null, filter ?? null] as const,
  listByTenant: (tenantId?: UUID) => ['roles', tenantId] as const,
  detail: (tenantId?: UUID, roleId?: UUID) =>
    ['role', tenantId, roleId] as const,
  myRoles: (tenantId?: UUID) => ['my-roles', tenantId] as const,
  permissionList: (tenantId?: UUID, roleId?: UUID, limit?: number) =>
    ['rolePermissions', tenantId, roleId, limit ?? null] as const,
  permissionListByRole: (tenantId?: UUID, roleId?: UUID) =>
    ['rolePermissions', tenantId, roleId] as const,
};

export const roleMutationKeys = {
  createRole: (tenantId?: UUID) => ['createRole', tenantId] as const,
  updateRole: (tenantId?: UUID, roleId?: UUID) =>
    ['updateRole', tenantId, roleId] as const,
  deleteRole: (tenantId?: UUID) => ['deleteRole', tenantId] as const,
  grantRolePermission: (tenantId?: UUID, roleId?: UUID) =>
    ['grantRolePermission', tenantId, roleId] as const,
  revokeRolePermission: (tenantId?: UUID, roleId?: UUID) =>
    ['revokeRolePermission', tenantId, roleId] as const,
};
